import { useCallback, useEffect, useState } from "react";
import { BookOpen, CalendarDays, Users } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import Pelatihan from "./Pelatihan";
import LearningWorkspace from "../components/learning/LearningWorkspace";
import LearningTeam from "../components/learning/LearningTeam";

const message = e => typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Ruang Belajar belum bisa dimuat. Silakan coba lagi.";

export default function PelatihanWorkspace() {
  const { branding } = useAuth();
  const { theme } = useTheme();
  const [tab, setTab] = useState("belajar"), [account, setAccount] = useState(null);
  const [role, setRole] = useState(""), [payload, setPayload] = useState(null);
  const [error, setError] = useState(""), [contextError, setContextError] = useState("");
  const [reload, setReload] = useState(0), [busy, setBusy] = useState(false);
  const refresh = useCallback(() => setReload(n=>n+1), []);
  useEffect(() => {
    let alive = true;
    setContextError("");
    api.get("/ruang-belajar/context").then(({data})=> {
      if(!alive) return;
      setAccount(data); setRole(r=>data.roles.some(x=>x.id===r) ? r : data.roles[0]?.id || "");
    }).catch(e=> { if(alive) setContextError(message(e)); });
    return()=> {alive=false;};
  }, [reload]);
  useEffect(() => {
    if(!role) return;
    let alive = true;
    setPayload(null); setError("");
    api.get(`/ruang-belajar/roles/${role}`).then(({data})=> {if(alive) setPayload(data);}).catch(e=> {if(alive) setError(message(e));});
    return()=> {alive=false;};
  }, [role, reload]);
  return <div className="pelatihan-workspace" data-theme={theme} data-testid="pelatihan-workspace">
    <div className="pelatihan-tabs" role="tablist" aria-label="Bagian pelatihan">
      {[["belajar",BookOpen,"Ruang Belajar"],["jadwal",CalendarDays,"Jadwal & Sertifikat"],...(account?.can_manage ? [["tim",Users,"Progres Tim"]]:[])].map(([id,Icon,label])=><button role="tab" aria-selected={tab===id} aria-controls={`pelatihan-panel-${id}`} id={`pelatihan-tab-${id}`} key={id} disabled={busy && tab!==id} onClick={()=>setTab(id)}><Icon size={17}/>{label}</button>)}
    </div>
    {busy && <p className="pelatihan-tab-hint">Selesaikan atau keluar dari tes, dan simpan catatan sebelum pindah bagian.</p>}
    <div role="tabpanel" id={`pelatihan-panel-${tab}`} aria-labelledby={`pelatihan-tab-${tab}`}>
      {tab==="jadwal" ? <Pelatihan/> : tab==="tim" ? <LearningTeam account={account} onAssignment={refresh}/> : contextError ? <div className="pelatihan-message" role="alert"><p>{contextError}</p><button onClick={refresh}>Coba lagi</button></div> : !account ? <p className="pelatihan-message" role="status">Memuat akun belajar…</p> : !role ? <div className="pelatihan-message"><BookOpen size={30}/><h2>Jalur belajarmu belum ditugaskan</h2><p>Minta pengelola memilih jalur sesuai jabatanmu melalui Pelatihan → Progres Tim.</p><button onClick={refresh}>Periksa lagi</button></div> : error ? <div className="pelatihan-message" role="alert"><p>{error}</p><button onClick={refresh}>Coba lagi</button></div> : !payload ? <p className="pelatihan-message" role="status">Menyiapkan materi belajarmu…</p> : <LearningWorkspace key={`${role}-${reload}`} payload={payload} role={role} account={account} onRole={setRole} onBusy={setBusy} brand={branding?.nama_toko_sendiri || branding?.app_name || "EppleHub"}/>}
    </div>
  </div>;
}
